import { useEffect, useState } from 'react';

interface Star {
	id: number;
	top: string;
	left: string;
	animationDuration: string;
	animationDelay: string;
	size: number;
}

interface StarFieldProps {
	count?: number;
}

export default function StarField({ count = 30 }: StarFieldProps) {
	const [stars, setStars] = useState<Star[]>([]);

	useEffect(() => {
		// Generate random stars
		const generateStars = () => {
			const newStars: Star[] = [];
			for (let i = 0; i < count; i++) {
				newStars.push({
					id: i,
					top: `${Math.random() * 100}%`,
					left: `${Math.random() * 100}%`,
					animationDuration: `${Math.random() * 3 + 2}s`,
					animationDelay: `${Math.random() * 5}s`,
					size: Math.random() > 0.5 ? 2 : 1
				});
			}
			setStars(newStars);
		};

		generateStars();
	}, [count]);

	return (
		<div className="stars-container">
			{stars.map((star) => (
				<div
					key={star.id}
					className="star"
					style={{
						top: star.top,
						left: star.left,
						animationDuration: star.animationDuration,
						animationDelay: star.animationDelay,
						width: `${star.size}px`,
						height: `${star.size}px`
					}}
				/>
			))}
		</div>
	);
}
